module.exports = __webpack_public_path__ + "img/11_102.0396adf7.png";